import { Box } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import FeaturesGrid from './FeaturesGrid';
import FlexiblePlans from './FlexiblePlans';

const Pricing = ({
  setOpenModalOrDrawer,
}: {
  setOpenModalOrDrawer: Dispatch<SetStateAction<boolean>>;
}) => {
  const getStartedHandler = () => {
    setOpenModalOrDrawer(true);
    AnalyticsHelper.logEvent({
      name: AnalyticsEventName.CTA_INTERACTED,
      data: {
        screen_name: ScreenName.PLANS_AND_PRICING,
        enrollment_initiated: true,
        cta_text: CtaText.GET_STARTED,
        cta_location: CtaLocation.Pricing,
        vertical: 'Unknown',
      },
    });
  };

  return (
    <Box
      data-testid="pricing-section"
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.palette.background.secondary,
      })}>
      <FeaturesGrid />
      <FlexiblePlans getStartedHandler={getStartedHandler} />
    </Box>
  );
};

export default Pricing;
